// HomePage is the landing page at / and /home. Static content only —
// no fetches, no URL state. Describes what The Cutline is for and
// where the data on every other page comes from, so a first-time
// visitor can orient without clicking around.

type Source = {
  label: string;
  origin: string;
  detail: string;
};

const SOURCES: Source[] = [
  {
    label: "Scores & schedules",
    origin: "NCAA.com",
    detail:
      "Live, final, and scheduled game data for every supported sport across Divisions I, II, and III is pulled from NCAA.com's public scoreboard feed.",
  },
  {
    label: "RPI (soccer)",
    origin: "NCAA.com rankings",
    detail:
      "Men's and women's soccer RPI standings come from NCAA.com's weekly rankings pages.",
  },
  {
    label: "NET & Quadrants (basketball)",
    origin: "NCAA.com rankings",
    detail:
      "The NET ranking plus a Quadrant 1–4 sidecar for men's and women's basketball is scraped from the NET rankings pages.",
  },
  {
    label: "Broadcasts",
    origin: "ESPN public API",
    detail:
      "TV channel and streaming metadata for televised games is enriched from ESPN's public scoreboard API and from each program's own schedule page.",
  },
  {
    label: "Rosters & team schedules",
    origin: "Athletic-department websites",
    detail:
      "Per-team rosters and non-conference schedules are parsed from each school's athletics site — Sidearm Sports, WMT Digital, Presto Sports, WordPress, and Nuxt-based builds are all supported.",
  },
  {
    label: "Teams & conferences",
    origin: "Project registry",
    detail:
      "The canonical list of programs and conferences across Divisions I, II, and III is a hand-curated YAML file checked into this project's source and refreshed as realignment happens.",
  },
];

export function HomePage() {
  return (
    <section className="home">
      <div className="page-head">
        <h2>The Cutline</h2>
      </div>

      <p className="home-lede">
        A no-frills reader for NCAA scores, schedules, and rankings
        across Divisions I, II, and III. Pick a sport and a division
        in the header; the tabs above take you to the day's games and
        the standings each sport is actually judged by — RPI for
        soccer, NET and Quadrants for basketball, records for
        football.
      </p>

      <h3 className="home-subhead">Where the data comes from</h3>
      <dl className="home-sources">
        {SOURCES.map((s) => (
          <div className="home-source" key={s.label}>
            <dt>
              {s.label}
              <span className="home-source-origin"> · {s.origin}</span>
            </dt>
            <dd>{s.detail}</dd>
          </div>
        ))}
      </dl>

      <p className="home-footnote">
        The Cutline is an independent reader. It is not affiliated with
        the NCAA, ESPN, or any athletic department. Source data is
        refreshed daily; small differences versus the originating sites
        are possible between refreshes.
      </p>
    </section>
  );
}
